import { render } from "./DefaultSizerIntro.vue?vue&type=template&id=1450b35a&scoped=true"
import script from "./DefaultSizerIntro.vue?vue&type=script&lang=js"
export * from "./DefaultSizerIntro.vue?vue&type=script&lang=js"

import "./DefaultSizerIntro.vue?vue&type=style&index=0&id=1450b35a&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-1450b35a"]])

export default __exports__